import { Link } from 'react-router-dom';
import '../assets/css/dropdown.css';
const Navbar = () => {
  return (
      <div className="navik-header">
          <div className="container">
		  
             {/*<!-- Navik header START -->*/}
			  <div className="navik-header-container">
				  <div className="burger-menu">
					  <div className="line-menu line-half first-line"></div>
					  <div className="line-menu"></div>
					  <div className="line-menu line-half last-line"></div>
				  </div>

				  <nav className="navik-menu menu-caret submenu-top-border submenu-scale">
				  
					  <ul className="list-unstyled" >
						  <li className="current-menu"><Link to="/"> <i className="fa fa-home"></i> Home</Link></li>
						  <li className="submenu-left"><Link to="/about">About Us</Link>
							<ul className="list-unstyled">
								<li><Link to="/about">Overview</Link></li>
								<li><Link to="/campus">Campus</Link></li>
								<li><Link to="/vision">Mission & Vision</Link></li>
								
								<li><Link to="/leadership&management">Management & Staff</Link>
								  <ul  className="list-unstyled">
									  <li><Link to="/leadership&management">Management</Link></li>
									  <li><Link to="/teaching_staff">Teaching Staff</Link></li>
									  <li><Link to="/non_teaching_staff">Non Teaching Staff</Link></li>									  
								  </ul>
								</li>
							</ul>
						  </li>
						  <li className="submenu-left"><Link to="/facility">Facility</Link>
								<ul  className="list-unstyled">
								  <li><Link to="/facility">Facility</Link></li>
								  <li><Link to="/classrooms">Smart Class Rooms</Link></li>
								  <li><Link to="/sports">Sports</Link></li>
								  <li><Link to="/library">School Library</Link></li>
								  <li><Link to="/labs">School Labs</Link></li>
								  <li><Link to="/transport">Transport Facility</Link></li>
								  <li><Link to="/music&dance">Music and dance</Link></li>
								  <li><Link to="/art&craft">Art and Craft</Link></li>
								  <li><Link to="/tour">Tour and excursions</Link></li>
								</ul>
						  </li>
						  <li className="submenu-left"><Link to="/addmission">Admissions</Link>
								<ul  className="list-unstyled">
								  <li><Link to="/addmission">Prospectus</Link></li>								  
								  <li><Link to="/fee">Fee Structure</Link></li>								  
								  <li><Link to="/addmissionpolicy">Admission Policy</Link></li>
								  								 
								</ul>
						  </li>
						 
						  <li><Link to="/news">News</Link></li>
						  <li><Link to="/events">Events</Link></li>
						  <li className="submenu-right"><Link to="/photogallery">Gallery</Link>
							  <ul  className="list-unstyled">
								  <li><Link to="/photogallery">Photo Gallery</Link></li>
								  <li><Link to="/videogallery">Video Gallery</Link></li>								  
							  </ul>
						  </li>
						  <li className="submenu-right"><Link to="/contact"><i className="fa fa-envelope"></i> Contact Us</Link></li>
						  
					  </ul>
				  </nav>

			  </div>
			{/*<!-- Navik header END -->*/}
          </div>
      </div>
  );
};
export default Navbar;